/**
 * Shared API response helpers used by web frontends.
 */

export function isJsonResponse(response: Response): boolean {
  const contentType = response.headers.get('content-type');
  return !!contentType && contentType.toLowerCase().startsWith('application/json');
}

export function validateJsonResponse(response: Response): void {
  if (!isJsonResponse(response)) {
    throw new Error('Unexpected server response. Please try again.');
  }
}

export async function extractErrorMessage(response: Response): Promise<string> {
  let errorMessage = response.statusText;

  if (isJsonResponse(response)) {
    try {
      const clonedResponse = response.clone();
      const errorData = await clonedResponse.json();
      errorMessage = errorData?.message || errorMessage;
    } catch {
      // Fall back to statusText when the body is not valid JSON.
    }
  }

  return errorMessage;
}
